import { TermsAndConditionsActionTypes, SET_TERMS_ACCEPTED, SET_TERMS_NOT_ACCEPTED } from './types';

export const setTermsAccepted = (): TermsAndConditionsActionTypes => ({
  type: SET_TERMS_ACCEPTED
});

export const setTermsNotAccepted = (): TermsAndConditionsActionTypes => ({
  type: SET_TERMS_NOT_ACCEPTED
});
